<template>
  <div class="my-role content-box" style="width: 60%">
    <loading :active="loading" background-color="transparent" />
    <!-- background-color="transparent" -->

    <div class="tab_null" v-if="jueseList.length <= 0">
      <center>
        <img src="@/assets/images/null.png" /> <br />
        暂无角色<br />点击上面“角色中心”选一个吧
      </center>
    </div>

    <div class="tab_role" v-if="jueseList.length > 2">
      <div
        class="tab_box"
        style="margin: 5px 0"
        v-for="(item, i) in jueseList"
        :key="i + 'juese'"
        @click="ModelCheck(item)"
      >
        <div
          class="tab_item"
          :class="{ tab_active: item.rolesId == user.rolesId }"
          :style="{ 'background-image': 'url(' + item.rolesPhoto + ')' }"
        >
          <span
            v-if="!item.parentId && item.rolesOpen"
            class="iconfont icon-fenxiang"
          ></span>
          <div class="tab_bottom tab_type2">
            {{ item.type == 1 ? "DB" : item.type == 2 ? "live2d" : "3D" }} ·
            {{ item.rolesOpen ? "共享" : "私有" }}
          </div>
          <div class="tab_edit">
            <div @click.stop="openEditUser(item)">
              <i class="iconfont icon-bianji"></i><span>编辑</span>
            </div>
            <div @click.stop="delUserModel(item.rolesId)">
              <i class="iconfont icon-remove-1-copy"></i><span>删除</span>
            </div>
          </div>
        </div>
        <div class="rolesname">{{ item.rolesName }}</div>
      </div>

      <div
        @click="morePage()"
        v-if="isShowLoad > 0 && !showEdit"
        style="
          margin: 10px 0;
          text-align: center;
          cursor: pointer;
          display: block;
          width: 100%;
          grid-column-start: 1;
          grid-column-end: 7;
        "
      >
        {{ loadtxt }}
      </div>
    </div>

    <div
      class="tab_role"
      v-if="jueseList.length == 1 || jueseList.length == 2"
      style="display: flex"
    >
      <div
        class="tab_box2"
        v-for="(item, i) in jueseList"
        :key="i + 'juese'"
        @click="ModelCheck(item)"
      >
        <div
          class="tab_item"
          :class="{ tab_active: item.rolesId == user.rolesId }"
          :style="{ 'background-image': 'url(' + item.rolesPhoto + ')' }"
        >
          <span
            v-if="!item.parentId && item.rolesOpen"
            class="iconfont icon-fenxiang"
          ></span>
          <div class="tab_bottom tab_type2">
            {{ item.type == 1 ? "DB" : item.type == 2 ? "live2d" : "3D" }} ·
            {{ item.rolesOpen ? "共享" : "私有" }}
          </div>
          <div class="tab_edit">
            <div @click.stop="openEditUser(item)">
              <i class="iconfont icon-bianji"></i><span>编辑</span>
            </div>
            <div @click.stop="delUserModel(item.rolesId)">
              <i class="iconfont icon-remove-1-copy"></i><span>删除</span>
            </div>
          </div>
        </div>
        <div class="rolesname">{{ item.rolesName }}</div>
      </div>
    </div>

    <!-- <div class="" id="myRole-Rongqi"> -->
    <!-- <div
        class="current_role"
        :style="{ 'background-image': 'url(' + user.rolesPhoto + ')' }"
      >
        <div class="current_role_bg">
          <div class="current_role_name">{{ user.rolesName }}</div>
          <div class="start_btn">
            <button @click="openshow">
              快速开始<span class="guangze"></span>
            </button>
          </div>
          <div class="about" @click="showAdds" style="z-index: 0">
            <i class="iconfont icon-gantanhao"></i>声明
          </div>
        </div>
      </div> -->
    <!-- </div> -->
  </div>
</template>
<script>
// import AddRole from '../role/AddRole.vue'

import { formatDate } from '@/components/util/util_fun.js'
import { localData } from '../../components/util/util_fun'

export default {
  name: 'Background',
  props: ['modelClass', 'user', 'modelloading', 'isshow', 'isH5'],
  components: {
    // AddRole
  },
  data () {
    return {

      showEdit: false,
      loading: true,
      editUser: {},
      action: [],//动画列表
      jueseList: [],

      param: {
        uid: this.$store.state.userinfo.userId,
        searchText: "",
        pageIndex: 0,
        pageSize: 18,
        sort: 1,
        modelId: "",//模型id
        type: '',//模型类型 0.龙骨 1.live3D
        sex: "",//性别 1.男 2.女
      },
      count: 0,
      loadtxt: '',
      isShowLoad: false,
      rolesPhoto: "",


    }
  },
  created () {


    // console.log('创建我的角色页');
    this.initParam()

    this.rolesPhoto = this.user.rolesPhoto
  },
  mounted () {


  },
  destroyed () {
    // console.log('销毁我的角色');;
  },
  methods: {

    showAdds () {
      this.showAdd = !this.showAdd
      this.$emit('showAdds')
    },
    //初始化
    initParam () {
      // console.log('执行了初始化');
      this.param.pageIndex = 0
      this.getUserModelList()

    },
    async openEditUser (user) {
      console.log('点击编辑发出请求获取密钥', user)
      const data = await this.post("/secret/getEncryptionInfo", { typeId: user.rolesId, type: 1 })
      if (data.status == "200") {
        if (data.data) { //获取密钥后调用父组件的编辑方法切换角色
          user.key = data.data
          console.log('点击编辑调用父组件的编辑方法', user)
          this.$emit('openEditUser', user)
        } else {
          console.log('没有key的编辑', user)

          this.$emit('openEditUser', user)

        }
      }
      else {
        this.$message.error("获得秘钥失败")
      }
    },
    closeEdit () {
      this.showEdit = false
    },
    //编辑成功后
    EditSuccess () {
      // debugger
      this.initParam()
      this.showEdit = false
    },
    //获取用户角色模型
    getUserModelList (searchText) {
      // console.log("加载我的角色");
      // debugger
      if (searchText) {
        this.param.searchText = searchText
        this.param.pageIndex = 0
      } else {
        this.param.searchText = ""
      }
      this.loading = true
      var that = this
      this.loadtxt = '加载中..'
      this.post("/roles/findModelList", this.param).then((res) => {
        that.loading = false
        if (res.status == "200") {

          var data = res.data[0]
          this.count = res.data[1]
          // console.log(data);
          for (var a = 0; a < data.length; a++) {
            data[a].isshow = false
            data[a].isHad = true
            data[a].createDate = formatDate(new Date(data[a].createDate), 'yyyy-MM-dd')
          }
          // that.jueseList=data;
          if (this.param.pageIndex == 0) {
            that.jueseList = data
          } else {
            that.jueseList = that.jueseList.concat(data)
          }

          var pageIndex = JSON.parse(JSON.stringify(that.param.pageIndex))

          if (((pageIndex + 1) * that.param.pageSize) >= that.count) {

            that.isShowLoad = false
            that.loadtxt = ''
          } else {

            that.isShowLoad = true
            that.loadtxt = '点击加载更多'
          }

          // if (!this.user.userId && isHad) {
          //   // console.log('使用的是角色中心的数据,更新为当前数组第一个新增的角色数据')
          //   // console.log('使用的是角色中心的数据,更新为当前数组第一个新增的角色数据', this.jueseList[0])
          //   this.$emit('checkRole', this.jueseList[0])
          //   // this.$emit('EditSuccess', this.jueseList[0])
          // };


        } else {
        }
      })
        .catch((e) => {
          that.loading = false
        })
    },
    //删除用户角色模型
    delUserModel (id) {

      if (this.user.rolesId == id) {
        this.$message.warning("当前角色正在使用中，不可删除！")
        return
      }

      var that = this
      this.$confirm({
        title: "操作提示",
        type: "warning",
        message: '删除角色后不可恢复！确定要删除该角色吗？'
      })
        .then(() => {

          that.loading = true

          that.post("/roles/delModel", { code: id }).then((res) => {
            that.loading = false
            if (res.status == "200") {

              that.$message.success("删除成功")

              for (var a = 0; a < that.jueseList.length; a++) {
                if (that.jueseList[a].rolesId == undefined) {
                  continue
                }
                if (that.jueseList[a].rolesId == id) {
                  that.jueseList.splice(a, 1)
                }

              }
            } else {
              that.$message.error("删除失败")

            }
          })
        })
        .catch(() => {
          that.loading = false
        })
      // this.$fire({
      //     title: "操作提示",
      //     text: "删除角色后不可恢复！确定要删除该角色吗？",
      //     type: "warning",
      // }).then(r => {
      // if(r.value){

      //     that.loading=true;

      //     that.post("/roles/delModel",{code:id}).then((res)=>{
      //         that.loading = false;
      //         if (res.status == "200") {

      //             that.$message.success("删除成功")

      //             for(var a=0;a<that.jueseList.length;a++){
      //                 if(that.jueseList[a].rolesId==undefined){
      //                     continue;
      //                 }
      //                 if(that.jueseList[a].rolesId==id){
      //                     that.jueseList.splice(a,1)
      //                 }

      //             }
      //         }else{
      //             that.$message.error("删除失败")

      //         }
      //     })
      //     .catch(()=>{
      //         that.loading = false;
      //     })
      // }
      // });


    },
    ModelCheck (user) {
      // console.log('角色user', user)

      this.post("/secret/getEncryptionInfo", {
        typeId: user.rolesId,
        type: 1
      }).then((res) => {
        if (res.status == "200") {
          if (res.data) {
            user.key = res.data
          }
          // console.log("获得秘钥",user);
          this.$emit("ModelCheck", user)
        }
        else {
          this.$message.error("获得秘钥失败")
        }
      })
        .catch((e) => {

        })
      // 


    },
    /**
     * 将集合中的对象更新
     */
    updateUser (user) {
      // console.log(this.jueseList,user)
      this.initParam()//方法会重新刷新页面

    },
    morePage () {
      var pageIndex = JSON.parse(JSON.stringify(this.param.pageIndex))


      if (((pageIndex + 1) * this.param.pageSize) >= this.count) {

      } else {
        this.param.pageIndex++
        this.getUserModelList()
      }

    },

    showBtn (item) {

      item.isshow = !item.isshow
    }
  },
  watch: {
    isshow: {
      deep: true,   //深度监听（用在监听对象属性的改变）
      handler (newVal, oldVal) {

        if (newVal == true) {

          var show = localStorage.getItem('showCenter')

          if (this.jueseList.length <= 0 && show == null && show != 1) {

            this.isShowLoad = false
            this.$message.info("当前您的角色列表为空,为您显示到角色中心列表")
            this.$emit('toCenter')
            localStorage.setItem('showCenter', 1)
          }

        }

      }
    }

  }

}
</script>
<style  lang="scss" scoped>
@import "@/style/mixin.scss";

/* live2d共享 */
.live2d_share {
  background: #dedee7;
  color: #9f9b9d;
}

.db_share {
  background: #f0acb7;
  color: #c57281;
}
.tab_role {
  height: 780px;
  //  display: grid;
  // grid-template-columns: repeat(6, 100px);
  // grid-template-columns: repeat(auto-fill, 100px);
  // grid-template-columns: repeat(5, 1fr);// 三种写法都行
  &::-webkit-scrollbar-thumb {
    display: unset;
    // @include background("scrollbar");
    background: #f0829b69;
  }
}
.tab_box{
  width: 20%; // 之前是flex更改为使用grid布局
  // width: 100%;
}
 @media screen and (max-height: 630px) {
  .tab_role {
    height: 540px;
  }
}
@media screen and (min-height: 650px) and (max-height: 730px) {
  .tab_role {
    height: 650px;
  }
} 
</style>